/* unplugin-vue-components disabled */import script from "./PageLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PageLayout.vue?vue&type=script&setup=true&lang=js"

import "./PageLayout.vue?vue&type=style&index=0&id=b75ffaca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b75ffaca"]])

export default __exports__